// ui related
import { LoadingButton } from "@mui/lab";
import { Typography } from "@mui/material";
import { InfoBox } from "Components/AllComponents";
import { FormSection } from "Components/BusinessView/FormSection";

export const DesignInspirations = () => {
  return (
    <FormSection id="inspirations" sectionName="Design inspirations">
      <InfoBox sx={{ mb: 2 }}>
        <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
          Disclaimer: AI-generated images may include unrealistic details that
          cannot be replicated. I do not create exact copies and will interpret
          the design in my own artistic style.
        </Typography>
      </InfoBox>
      <LoadingButton variant="outlined" component="label" disabled>
        Attach images
        <input hidden accept="image/*" multiple type="file" />
      </LoadingButton>
    </FormSection>
  );
};
